import React, { useState } from 'react';
import { useModal } from '../../context/ModalContext';
import './FAQ.css';

const FAQ = () => {
  const { openModal } = useModal();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What NEET score do I need for MBBS abroad?',
      answer: 'Most NMC-recognised universities accept students with 150+ qualifying marks. Russia and Philippines are popular for scores in the 200–400 range, while higher scores open doors to better-ranked universities globally.'
    },
    {
      question: 'Is an MBBS degree from abroad valid in India?',
      answer: 'Yes — if the university is NMC-recognised and you clear the FMGE/NExT screening exam, you can practice medicine in India. MyCollegeBuddy only recommends NMC-approved institutions.'
    },
    {
      question: 'How much does MBBS abroad cost in total?',
      answer: 'Total cost (tuition + accommodation) for a 6-year MBBS ranges from ₹12–40 lakhs depending on country and university. Russia and Kazakhstan are among the most affordable options available.'
    },
    {
      question: "Is MyCollegeBuddy's counselling really free?",
      answer: 'Absolutely. All counselling, college matching, and roadmap services are 100% free for students. We are compensated by our partner universities, letting us offer a completely no-cost service with zero obligation.'
    },
    {
      question: "Can I apply if I haven't taken NEET yet?",
      answer: "Yes! Many students connect with us 6–12 months before their NEET attempt. Early planning gives you a significant advantage and ensures you don't miss application deadlines."
    },
    {
      question: 'Do you help with accommodation?',
      answer: 'Full end-to-end support includes documentation, forex, accommodation booking, and pre-departure orientation. Our on-ground team in key destinations also supports you after arrival.'
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section" id="faq">
      <div className="section-inner">

        {/* ── CTA Banner (above FAQ) ── */}
        <div className="faq-cta-banner reveal">
          <div className="faq-cta-inner">
            <div className="faq-cta-left">
              <div className="faq-cta-badge">🚀 2026 Admissions Open</div>
              <h3 className="faq-cta-title">
                Ready to Start Your <span>MBBS Journey?</span>
              </h3>
              <p className="faq-cta-sub">
                Join 2,500+ students who found their perfect college with MyCollegeBuddy.
                Get a free personalised roadmap — zero cost, zero obligation.
              </p>
              <div className="faq-cta-btns">
                <button onClick={openModal} className="faq-cta-btn-primary">
                  Get Free Counselling →
                </button>
                
              </div>
            </div>
            <div className="faq-cta-right">
              <div className="faq-cta-stats">
                <div className="faq-stat">
                  <div className="faq-stat-num">2,500+</div>
                  <div className="faq-stat-lbl">Students Placed</div>
                </div>
                <div className="faq-stat">
                  <div className="faq-stat-num">50+</div>
                  <div className="faq-stat-lbl">Partner Colleges</div>
                </div>
                <div className="faq-stat">
                  <div className="faq-stat-num">6+</div>
                  <div className="faq-stat-lbl">Years Experience</div>
                </div>
                <div className="faq-stat">
                  <div className="faq-stat-num">100%</div>
                  <div className="faq-stat-lbl">Free Service</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── FAQ section ── */}
        <div className="faq-outer">
          <div className="faq-hd reveal">
            <div className="sec-label" style={{ justifyContent: 'center' }}>FAQ</div>
            <h2 className="sec-title">Frequently Asked Questions</h2>
            <p className="sec-sub" style={{ margin: '0.5rem auto 0', textAlign: 'center', maxWidth: '440px' }}>
              Everything you need to know before taking the first step.
            </p>
          </div>
          <div className="reveal">
            {faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
                <button className="faq-q" onClick={() => toggleFaq(index)}>
                  {faq.question}
                  <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
                </button>
                <div className="faq-a">{faq.answer}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FAQ;